import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';

@Component({
  selector: 'app-avt-gest-droit-user',
  templateUrl: './avt-gest-droit-user.component.html',
  styleUrls: ['./avt-gest-droit-user.component.scss'],
})
export class AvtGestDroitUserComponent implements OnInit {
  constructor(public generalService: GeneralService) {}
  exist = true;
  menu;
  droitAccerMenu;
  disabledBtnAjouter: boolean = false;
  disabledBtnEnregistrer: boolean = false;
  disabledBtnModifier: boolean = false;
  disabledBtnSupprimer: boolean = false;
  listeMenu = [];
  listeAllDroitAccer = [];
  listeDroitAccerMenu = [];
  listeDroitAccerMenuSelected;

  listeDroitAccerMenuNotSelected = [];
  listeDroitAccerSelected = [];
  @ViewChild('listeComponen', { static: false })
  listeComponen: AvtListesComponent;
  @ViewChild('listeAllRightComponen', { static: false })
  listeAllRightComponen: AvtListesComponent;
  initDroitAccerMenu;
  // listBtn:Array<any> = [{name:"enregistrer",class:"colorGreen",text:"Enregistrer"}];
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'For_Code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'For_Parent',
        Lg_Code: '',
        TableRD_Des: 'Menu',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'For_Item',
        Lg_Code: '',
        TableRD_Des: 'Sous menu',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      // {"TableRE_Code":"","TableRD_Champs":"Menu_Ajout","Lg_Code":"","TableRD_Des":"Ajout","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":1,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_Modif","Lg_Code":"","TableRD_Des":"Modif","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_Supp","Lg_Code":"","TableRD_Des":"Supp","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":3,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_Valid","Lg_Code":"","TableRD_Des":"Validé","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_Imprime","Lg_Code":"","TableRD_Des":"Imprimé","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_GEDAjout","Lg_Code":"","TableRD_Des":"Ajout GED","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":6,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_GEDModif","Lg_Code":"","TableRD_Des":"Modif GED","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":7,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      // {"TableRE_Code":"","TableRD_Champs":"Menu_GEDSupp","Lg_Code":"","TableRD_Des":"Supp GED","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":8,"TableRD_Type":1,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ],
  };

  columnsAllRight = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'For_Code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'parent',
        Lg_Code: '',
        TableRD_Des: 'Menu',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'name',
        Lg_Code: '',
        TableRD_Des: 'Sous menu',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  listBtn: Array<any> = [
    {
      name: 'ajouter',
      class: 'colorBlue',
      text: 'Modifier',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'ajouter',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];
  ngOnInit() {
    //,TableRD_MiltipleSelect:true
    this.menu = {};
    this.droitAccerMenu = {};
    this.getListeMenu();
    this.getListeDroitAccer();
    this.getInitDroitAccerMenu();
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'modifier': {
        this.modifierMenu();
        break;
      }
      case 'supprimer': {
        this.supprimerMenu();
        break;
      }
    }
  }
  getListeMenu() {
    this.generalService
      .rechercheTable(this.generalService.urlListeMenu)
      .subscribe((menus) => {
        this.listeMenu = this.generalService.sort(menus, 'Menu_Code');
      });
  }
  getListeDroitAccer() {
    this.generalService
      .rechercheTable(this.generalService.urlListeDroitAccer)
      .subscribe((droitAccer) => {
        this.listeAllDroitAccer = droitAccer;
      });
  }
  getInitDroitAccerMenu() {
    this.generalService
      .rechercheTable(this.generalService.urlMenu)
      .subscribe((menu) => {
        this.initDroitAccerMenu = menu;
        this.menu = menu.Menu[0];
      });
  }
  ajouterMenu(formMenu) {
    if (formMenu.form.valid) {
      if (
        this.listeMenu.find((menu) => {
          return (
            menu.Menu_Code.toLowerCase() == this.menu.Menu_Code.toLowerCase()
          );
        }) == undefined
      ) {
        this.disabledBtnAjouter = true;
        this.exist = false;
        console.log(this.initDroitAccerMenu);

        this.generalService.enregisterTable(this.initDroitAccerMenu).subscribe(
          (data) => {
            this.getListeMenu();
            this.generalService.dialogSuccess('Enregistré', true);
            this.disabledBtnAjouter = false;
            this.exist = true;
          },
          (err) => {
            this.disabledBtnAjouter = false;
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
      } else {
        this.generalService.dialogSuccess('La menue saisie existe déjà', false);
      }
    }
  }
  modifierMenu() {
    this.disabledBtnModifier = true;
    this.exist = false;
    this.generalService
      .enregisterTable(this.listeDroitAccerMenuSelected)
      .subscribe(
        (data) => {
          this.generalService.dialogSuccess('Enregistré', true);
          this.disabledBtnModifier = false;
          this.exist = true;
        },
        (err) => {
          this.disabledBtnModifier = false;
          this.exist = true;
          this.generalService.dialogSuccess('Non enregistré', false);
        }
      );
  }
  enregistrerDroitAccer(formDroitAccer) {}
  onMenuChange(Menu_Code) {
    this.generalService
      .rechercheTable(this.generalService.urlMenu + '&val=' + Menu_Code)
      .subscribe((data) => {
        this.listeDroitAccerMenuSelected = data;
        this.listeComponen.setDataSource(this.listeDroitAccerMenuSelected.Menu);
        this.setListeDroitAccerMenuNotSelected();
      });
  }
  setListeDroitAccerMenuNotSelected() {
    this.listeDroitAccerMenuNotSelected = [];
    this.listeAllDroitAccer.forEach((droit) => {
      var find = this.listeDroitAccerMenuSelected.Menu.find((droitSelected) => {
        return droitSelected.For_Code == droit.For_Code;
      });
      if (find == undefined) this.listeDroitAccerMenuNotSelected.push(droit);
    });
    this.listeAllRightComponen.setDataSource(
      this.listeDroitAccerMenuNotSelected
    );
  }
  addDroit() {
    if (this.initDroitAccerMenu != undefined) {
      [this.listeAllRightComponen.row].forEach((element) => {
        this.listeDroitAccerMenuNotSelected =
          this.listeDroitAccerMenuNotSelected.filter((droit) => {
            return droit.For_Code.toString() != element.For_Code.toString();
          });
        var initDroitAccerMenu = this.generalService.clone(
          this.initDroitAccerMenu.Menu[0]
        );
        var s = this.generalService.clone(
          this.listeAllDroitAccer.find((dr) => {
            return dr.For_Code == element.For_Code;
          })
        );
        initDroitAccerMenu.For_Code = s.For_Code;
        initDroitAccerMenu.Menu_Code = this.generalService.clone(
          this.droitAccerMenu.Menu_Code
        );
        initDroitAccerMenu.name = s.name;

        this.listeDroitAccerMenuSelected.Menu.push(initDroitAccerMenu);
      });
      this.listeAllRightComponen.setDataSource(
        this.listeDroitAccerMenuNotSelected
      );
      this.listeAllRightComponen.row = null;
      this.listeComponen.setDataSource(this.listeDroitAccerMenuSelected.Menu);
    }
  }
  removeDroit() {
    [this.listeComponen.row].forEach((element) => {
      this.listeDroitAccerMenuSelected.Menu =
        this.listeDroitAccerMenuSelected.Menu.filter((droit) => {
          return droit.For_Code != element.For_Code;
        });
    });
    this.listeComponen.setDataSource(this.listeDroitAccerMenuSelected.Menu);
    this.setListeDroitAccerMenuNotSelected();
  }
  supprimerMenu() {
    if (this.listeComponen.row) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(
            this.listeComponen.row.Menu_Id,
            'menuSup'
          );
          if (deleteFn != null) {
            this.exist = false;
            this.disabledBtnSupprimer = true;
            deleteFn.subscribe(
              (data) => {
                this.onMenuChange(this.droitAccerMenu.Menu_Code);
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.exist = true;
                this.disabledBtnSupprimer = false;
              },
              (error) => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
                this.disabledBtnSupprimer = false;
              }
            );
          }
        }
        if (result == 'annuler') {
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
  }
}
